import React from "react";

const TONE = {
  OPEN: "bg-emerald-50 text-emerald-700 border-emerald-200",
  CLOSED: "bg-slate-100 text-slate-700 border-slate-200",
  UNKNOWN: "bg-slate-100 text-slate-500 border-slate-200",
  NORMAL: "bg-emerald-50 text-emerald-700 border-emerald-200",
  OFFLINE: "bg-slate-100 text-slate-500 border-slate-200",
  FAULT: "bg-red-50 text-red-700 border-red-200",
  ACTIVE: "bg-emerald-50 text-emerald-700 border-emerald-200",
  SUSPENDED: "bg-amber-50 text-amber-800 border-amber-200",
  CLOSED_ACC: "bg-slate-100 text-slate-500 border-slate-200",
  INFO: "bg-sky-50 text-sky-700 border-sky-200",
  WARN: "bg-amber-50 text-amber-800 border-amber-200",
  CRITICAL: "bg-red-50 text-red-700 border-red-200",
  PENDING: "bg-amber-50 text-amber-800 border-amber-200",
  SENT: "bg-sky-50 text-sky-700 border-sky-200",
  ACK: "bg-emerald-50 text-emerald-700 border-emerald-200",
  FAILED: "bg-red-50 text-red-700 border-red-200",
  APPLIED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  LORAWAN: "bg-indigo-50 text-indigo-700 border-indigo-200",
  UDP: "bg-purple-50 text-purple-700 border-purple-200",
  PREPAID: "bg-blue-50 text-blue-700 border-blue-200",
  POSTPAID: "bg-slate-100 text-slate-700 border-slate-200",
};

const DOT = {
  OPEN: "bg-emerald-500",
  CLOSED: "bg-slate-400",
  UNKNOWN: "bg-slate-300",
  NORMAL: "bg-emerald-500",
  OFFLINE: "bg-slate-400",
  FAULT: "bg-red-500",
  ACTIVE: "bg-emerald-500",
  SUSPENDED: "bg-amber-500",
  INFO: "bg-sky-500",
  WARN: "bg-amber-500",
  CRITICAL: "bg-red-500",
  PENDING: "bg-amber-500",
  SENT: "bg-sky-500",
  ACK: "bg-emerald-500",
  FAILED: "bg-red-500",
  APPLIED: "bg-emerald-500",
  LORAWAN: "bg-indigo-500",
  UDP: "bg-purple-500",
  PREPAID: "bg-blue-500",
  POSTPAID: "bg-slate-500",
};

export default function StatusPill({ value, label, className = "", testId }) {
  const key = value || "UNKNOWN";
  const tone = TONE[key] || "bg-slate-100 text-slate-700 border-slate-200";
  const dot = DOT[key] || "bg-slate-400";
  return (
    <span data-testid={testId} className={`status-pill border ${tone} ${className}`}>
      <span className={`status-dot ${dot}`} />
      {label || String(value || "—")}
    </span>
  );
}
